import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { IntroAssessmentPage } from './pages/IntroAssessmentPage';
import { AssessmentPage } from './pages/AssessmentPage';
import { GoalsAssessmentPage } from './pages/GoalsAssessmentPage';
import { AssessmentTransitionPage } from './pages/AssessmentTransitionPage';
import { AssessmentQuizPage } from './pages/AssessmentQuizPage';
import { AssessmentResultsPage } from './pages/AssessmentResultsPage';
import { SelfAssessmentPage } from './pages/SelfAssessmentPage';
import { FamilyAssessmentPage } from './pages/FamilyAssessmentPage';
import { LovedOneAssessmentPage } from './pages/LovedOneAssessmentPage';
import { ComingSoonPage } from './pages/ComingSoonPage';
import { IndividualsPage } from './pages/IndividualsPage';
import { FamiliesPage } from './pages/FamiliesPage';
import { AboutUsPage } from './pages/AboutUsPage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { PricingPage } from './pages/PricingPage';
import { ButtonColorTestPage } from './pages/ButtonColorTestPage';
import { ColorComparisonPage } from './pages/ColorComparisonPage';
import { FontTestPage } from './pages/FontTestPage';
import { PurpleColorTestPage } from './pages/PurpleColorTestPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { InvestorDeckPage } from './pages/InvestorDeckPage';
import { InvestorOverviewPage } from './pages/InvestorOverviewPage';
import { InvestorRoadmapPage } from './pages/InvestorRoadmapPage';
import { InvestorBusinessPlanPage } from './pages/InvestorBusinessPlanPage';
import { InvestorResearchPage } from './pages/InvestorResearchPage';
import { CrisisResponsePage } from './pages/CrisisResponsePage';
import { CAGuidePage } from './pages/CAGuidePage';
import { ResourcesPage } from './pages/ResourcesPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { SpamGuidePage } from './pages/SpamGuidePage';
import { InvestPage } from './pages/InvestPage';
export function AppRouter() {
  return <HashRouter data-id="element-13">
      <Routes data-id="element-14">
        <Route path="/" element={<ComingSoonPage data-id="element-16" />} data-id="element-15" />
        <Route path="/home" element={<App data-id="element-18" />} data-id="element-17" />
        <Route path="/intro-assessment" element={<IntroAssessmentPage data-id="element-20" />} data-id="element-19" />
        <Route path="/assessment" element={<AssessmentPage data-id="element-22" />} data-id="element-21" />
        <Route path="/assessment/goals" element={<GoalsAssessmentPage data-id="element-24" />} data-id="element-23" />
        <Route path="/assessment/transition" element={<AssessmentTransitionPage data-id="element-26" />} data-id="element-25" />
        <Route path="/assessment/quiz" element={<AssessmentQuizPage data-id="element-28" />} data-id="element-27" />
        <Route path="/assessment/results" element={<AssessmentResultsPage data-id="element-30" />} data-id="element-29" />
        <Route path="/assessment/self" element={<SelfAssessmentPage data-id="element-32" />} data-id="element-31" />
        <Route path="/assessment/family" element={<FamilyAssessmentPage data-id="element-34" />} data-id="element-33" />
        <Route path="/assessment/loved-one" element={<LovedOneAssessmentPage data-id="element-36" />} data-id="element-35" />
        <Route path="/individuals" element={<IndividualsPage data-id="element-38" />} data-id="element-37" />
        <Route path="/families" element={<FamiliesPage data-id="element-40" />} data-id="element-39" />
        <Route path="/about-us" element={<AboutUsPage data-id="element-42" />} data-id="element-41" />
        <Route path="/how-it-works" element={<HowItWorksPage data-id="element-44" />} data-id="element-43" />
        <Route path="/pricing" element={<PricingPage data-id="element-46" />} data-id="element-45" />
        <Route path="/test/button-colors" element={<ButtonColorTestPage data-id="element-48" />} data-id="element-47" />
        <Route path="/test/color-comparison" element={<ColorComparisonPage data-id="element-50" />} data-id="element-49" />
        <Route path="/test/fonts" element={<FontTestPage data-id="element-52" />} data-id="element-51" />
        <Route path="/test/purple-colors" element={<PurpleColorTestPage data-id="element-54" />} data-id="element-53" />
        <Route path="/investor-portal" element={<InvestorDeckPage data-id="element-56" />} data-id="element-55" />
        <Route path="/investor-overview" element={<InvestorOverviewPage data-id="element-58" />} data-id="element-57" />
        <Route path="/investor-roadmap" element={<InvestorRoadmapPage data-id="element-60" />} data-id="element-59" />
        <Route path="/investor-plan" element={<InvestorBusinessPlanPage data-id="element-62" />} data-id="element-61" />
        <Route path="/investor-research" element={<InvestorResearchPage data-id="element-64" />} data-id="element-63" />
        <Route path="/invest" element={<InvestPage data-id="element-66" />} data-id="element-65" />
        <Route path="/crisis-help" element={<CrisisResponsePage data-id="element-68" />} data-id="element-67" />
        <Route path="/resources" element={<ResourcesPage data-id="element-70" />} data-id="element-69" />
        <Route path="/resources/ca-guide" element={<CAGuidePage data-id="element-72" />} data-id="element-71" />
        <Route path="/resources/spam-guide" element={<SpamGuidePage data-id="element-74" />} data-id="element-73" />
        <Route path="/privacy" element={<PrivacyPolicyPage data-id="element-76" />} data-id="element-75" />
        <Route path="*" element={<NotFoundPage data-id="element-78" />} data-id="element-77" />
      </Routes>
    </HashRouter>;
}